"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = convertObjectKeysToSnakeCase;

function convertObjectKeysToSnakeCase(object) {
  var newObject = {};

  for (var key in object) {
    var snakeCaseKey = key.toLowerCase().replace(/ /g, '_');
    newObject[snakeCaseKey] = object[key];
  }

  return newObject;
}